import * as React from 'react';

export function useSidebarKeyboardShortcut({
  isDesktop,
  toggleDesktopCollapsed,
  toggleMobileOpen,
}: {
  isDesktop: boolean;
  toggleDesktopCollapsed: () => void;
  toggleMobileOpen: () => void;
}): void {
  React.useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const isEditableTarget = (target: EventTarget | null) => {
      if (!(target instanceof HTMLElement)) return false;
      const tag = target.tagName.toLowerCase();
      return tag === 'input' || tag === 'textarea' || target.isContentEditable;
    };

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.defaultPrevented) return;
      if (!(event.ctrlKey || event.metaKey) || event.altKey || event.shiftKey) {
        return;
      }
      if (event.key.toLowerCase() !== 'b') return;
      if (isEditableTarget(event.target)) return;

      event.preventDefault();
      if (isDesktop) {
        toggleDesktopCollapsed();
      } else {
        toggleMobileOpen();
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isDesktop, toggleDesktopCollapsed, toggleMobileOpen]);
}
